import { IconType } from "react-icons";

interface EmptyStateProps {
    message?: string;
    showIcon?: boolean;
    icon?: IconType;
    iconSize?: number
}

const EmptyState = ({ message, showIcon = false, icon: Icon, iconSize = 16 }: EmptyStateProps) => (
    <div className="bg-system-light-20 rounded-md mt-4 flex items-start gap-2 p-4 w-full">
        {showIcon && (
            Icon && <div style={{ width: iconSize, height: iconSize }}><Icon size={iconSize} /></div>
        )}
        <p className="text-bmedium text-[#2C3134]">
            {message}
        </p>
    </div>
);

export default EmptyState;